import { motion } from "framer-motion";
import { waLink, DEFAULT_WA_MESSAGE } from "../../lib/site";
import { WhatsAppIcon } from "./Header";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={waLink(DEFAULT_WA_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-trigger"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 w-15 h-15 sm:w-16 sm:h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl shadow-[#25D366]/40 live-dot"
      aria-label="Falar no WhatsApp agora"
    >
      <WhatsAppIcon className="w-7 h-7 text-black" />
      <span className="absolute -top-1 -right-1 bg-[#e8112d] text-white font-tech text-[10px] font-bold px-1.5 py-0.5 rounded-full">
        24h
      </span>
    </motion.a>
  );
}
